import React from 'react';
import { useSiteData } from 'react-static';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import List from '@nmx/template/dist/componentLibrary/components/List';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// styles
import {
  ColStyledDownloadLinkContainer,
  ListItemStyled,
  SectionContainerStyled,
} from './styles';

export default () => {

  const { config } = useSiteData();

  return (
    <SectionContainerStyled
      id='other-account-portals'
      backgroundVariant='lightC'
      themeType='lightTheme'>
      <Row>
        <Col>
          <Typography
            component='h2'
            align='center'>
            Get anywhere access, <WidowBlock>go mobile</WidowBlock>
          </Typography>
        </Col>
      </Row>
      <Row>
        <Col>
          <Row align='center'>
            <ColStyledDownloadLinkContainer align='center'>
              <List reduced>
                <ListItemStyled>
                  <Link linkUrl='https://northwesternmutual.page.link/?link=https%3A%2F%2Fwww.northwesternmutual.com%2Fapp%2Fcampaign%3Futm_source%3Dnmcom_log-in%26utm_medium%3Dweb%26utm_campaign%3Dmobileappbadges_Q4_2022%26utm_content%3Dclient_mobileappdownload%26utm_term%3Dios&apn=com.nm.nm&amv=0&ibi=com.nm.nm.ios&isi=1132579006&st=To%20continue%20%26%20download%20the%20app%2C%20click%20%22OPEN%22%20below.&sd=Northwestern%20Mutual%20Mobile%20App&ofl=https%3A%2F%2Fapps.apple.com%2Fus%2Fapp%2Fnorthwestern-mutual%2Fid1132579006' isOutgoingLink>
                    <img
                      alt='Download on the App Store'
                      src={`${config.basePath}/template/assets/${config.nmxTemplateVersion}/images/badges/apple-app-store-badge.svg`} className='nmx-icon badge-appStore' />
                  </Link>
                </ListItemStyled>
                <ListItemStyled>
                  <Link linkUrl='https://northwesternmutual.page.link/?link=https%3A%2F%2Fwww.northwesternmutual.com%2Fapp%2Fcampaign%3Futm_source%3Dnmcom_log-in%26utm_medium%3Dweb%26utm_campaign%3Dmobileappbadges_Q4_2022%26utm_content%3Dclient_mobileappdownload%26utm_term%3Dandroid&apn=com.nm.nm&amv=0&ibi=com.nm.nm.ios&isi=1132579006&st=To%20continue%20%26%20download%20the%20app%2C%20click%20%22OPEN%22%20below.&sd=Northwestern%20Mutual%20Mobile%20App&ofl=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.nm.nm' isOutgoingLink>
                    <img
                      alt='Get it on Google Play'
                      src={`${config.basePath}/template/assets/${config.nmxTemplateVersion}/images/badges/google-play-badge.png`}
                      className='nmx-icon badge-googlePlay' />
                  </Link>
                </ListItemStyled>
              </List>
            </ColStyledDownloadLinkContainer>
          </Row>
        </Col>
      </Row>
    </SectionContainerStyled>
  );
};
